module.exports = __webpack_public_path__ + "img/ic24ArrowL.22879907.svg";